import { getTemplates } from './templates';

export const formatTemplate = (templateKey, userFirstName, userPreferredName, agentFirstName, agentLastName, agent) => {
  const templates = getTemplates({ firstName: agentFirstName, lastName: agentLastName, agent });
  const template = templates[templateKey]?.html;
  return template
    .replace(/firstName/g, userFirstName)
    .replace(/agentName/g, agentFirstName)
    .replace(/preferredName/g, userPreferredName || userFirstName);
};
